var a={loadingBtn:"loadingBtn__TneI1O","spin-animation":"spin-animation__PBEJZ5","ball-beat-animation":"ball-beat-animation__aDJG3Z","hide-scroll-animation":"hide-scroll-animation__FvVzkr"};export{a as default};
